import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import { InviteNotificationListener } from "@/components/InviteNotificationListener";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Homepage from "@/pages/Homepage";
import Matchmaking from "@/pages/Matchmaking";
import VideoCall from "@/pages/VideoCall";
import AIReview from "@/pages/AIReview";
import History from "@/pages/History";
import Profile from "@/pages/Profile";
import Practice from "@/pages/Practice";
import SessionReview from "@/pages/SessionReview";
import Friends from "@/pages/Friends";
import AdminFeedback from "@/pages/AdminFeedback";
import AdminUsers from "@/pages/AdminUsers";
import PreCall from "@/pages/PreCall";
import PracticeSetup from "@/pages/PracticeSetup";
import Briefing from "@/pages/Briefing";
import AudioDebug from "@/pages/AudioDebug";
import About from "@/pages/About";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/about" element={<About />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route
        path="/homepage"
        element={
          <ProtectedRoute>
            <Homepage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/matchmaking"
        element={
          <ProtectedRoute>
            <Matchmaking />
          </ProtectedRoute>
        }
      />
      <Route path="/audio-debug" element={<AudioDebug />} />
      <Route
        path="/practice-setup"
        element={
          <ProtectedRoute>
            <PracticeSetup />
          </ProtectedRoute>
        }
      />
      <Route
        path="/briefing"
        element={
          <ProtectedRoute>
            <Briefing />
          </ProtectedRoute>
        }
      />
      <Route
        path="/pre-call"
        element={
          <ProtectedRoute>
            <PreCall />
          </ProtectedRoute>
        }
      />
      <Route
        path="/video-call"
        element={
          <ProtectedRoute>
            <VideoCall />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ai-review"
        element={
          <ProtectedRoute>
            <AIReview />
          </ProtectedRoute>
        }
      />
      <Route
        path="/history"
        element={
          <ProtectedRoute>
            <History />
          </ProtectedRoute>
        }
      />
      <Route
        path="/friends"
        element={
          <ProtectedRoute>
            <Friends />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />
      <Route
        path="/practice"
        element={
          <ProtectedRoute>
            <Practice />
          </ProtectedRoute>
        }
      />
      <Route
        path="/review/:id"
        element={
          <ProtectedRoute>
            <SessionReview />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/feedback"
        element={
          <ProtectedRoute>
            <AdminFeedback />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/users"
        element={
          <ProtectedRoute>
            <AdminUsers />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App sp-noise font-body">
      <BrowserRouter>
        <AuthProvider>
          <InviteNotificationListener />
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" />
    </div>
  );
}

export default App;
